<template>
    <div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <form @submit.prevent="update">
            <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()" @keydown="dirtyForm">
                <select-input id="titles" v-model="form.title_id" :error="form.errors?.title_id" class="pr-6" label="* Title" @update:modelValue="value = $event">
                    <option v-for="(name, reference) in titlesList" :key="reference" :value="reference">{{ name }}</option>
                </select-input>
                <text-input v-model="form.first_name" :error="form.errors?.first_name" label="* First name" @update:modelValue="value = $event" />
                <text-input v-model="form.middle_name1" :error="form.errors?.middle_name1" class="pr-6" label="Middle name 1" @update:modelValue="value = $event" />
                <text-input v-model="form.middle_name2" :error="form.errors?.middle_name2" class="pr-6" label="Middle name 2" @update:modelValue="value = $event" />
                <text-input v-model="form.last_name" :error="form.errors?.last_name" label="* Last name" @update:modelValue="value = $event" />
                <text-input v-model="form.preferred_name" :error="form.errors?.preferred_name" class="pr-6" label="* Preferred name" @update:modelValue="value = $event" />
                <text-input v-model="form.date_of_birth" :error="form.errors?.date_of_birth" type="date" name="date_of_birth" label="* Date of birth"
                            @update:modelValue="value = $event"
                />
                <select-input id="pd_gender" v-model="form.gender_id" :error="form.errors?.gender_id" class="pr-6" label="* Gender" @update:modelValue="value = $event">
                    <option v-for="gender in genders" :key="gender.reference" :value="gender.reference">{{ gender.name }}</option>
                </select-input>
            </div>
            <div v-if="successMessage.length > 0" class="success-message m-8 w-auto">Personal details updated</div>
            <div v-if="validationErrors !== undefined">
                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error m-8">There were some validation issues, please check the fields above</p>
                </div>
            </div>
            <div class="lg:flex justify-end w-full pb-2 -mt-8">
                <div class="relative w-auto lg:w-1/3 mx-8">
                    <application-component-save-button :disabled="formDirty" class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                       type="submit"
                    >
                        Save Personal Details
                        <div v-if="loading" class="lds-ring-container absolute top-10">
                            <div class="lds-ring">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    </application-component-save-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    components: {
        TextInput,
        SelectInput,
        ApplicationComponentSaveButton,
    },
    props: {
        reference: String,
        personalData: Object,
        applicationData: Object,
        genders: Array,
        titlesList: Object,
        countriesOfDomicileList: Object,
        countriesOfBirthList: Object,
    },
    data() {
        return {
            form: ({
                first_name: this.personalData.first_name,
                last_name: this.personalData.last_name,
                middle_name1: this.personalData.middle_name1,
                middle_name2: this.personalData.middle_name2,
                preferred_name: this.personalData.preferred_name,
                date_of_birth: new Date(this.personalData.date_of_birth).toISOString().split('T')[0],
                gender_id: this.personalData.gender_id,
                title_id: this.personalData.title_id,
                errors: {},
            }),
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    methods: {
        update() {
            this.loading = true
            this.$store.dispatch('updatePersonalDetails', {
                personalData: this.form,
                reference: this.personalData.reference,
            })
                .then(() => {
                    this.loading = false
                    this.serverErrors = ''
                    this.successMessage = 'Personal details updated'
                    this.form.errors = {}
                })
                .catch(error => {
                    this.loading = false
                    this.form.errors = error.response.data.errors
                    this.validationErrors = error.response.data.errors
                    this.successMessage = ''
                })
            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>